import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadList: -1,
    loadChartList: -1,
  },
  records: [],
  chartRecords: [],
  extras: {
    currentPage: 0,
    pageSize: 15,
    total: 0,
  },
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.LAB_RESULTS_READINGS_HISTORY_REQUESTED:
      return {
        ...state,
        status: {
          loadList: 0,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_READINGS_HISTORY_SUCCEED:
      return {
        ...state,
        status: {
          loadList: 1,
        },
        records: payload.data,
        extras: {
          currentPage: payload.pagination.page,
          pageSize: payload.pagination.pages,
          total: payload.pagination.total,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_READINGS_HISTORY_FAILED:
      return {
        ...state,
        status: {
          loadList: 2,
        },
        error,
      };
    case ACTION_TYPES.LAB_RESULTS_CHART_READINGS_HISTORY_REQUESTED:
      return {
        ...state,
        status: {
          loadChartList: 0,
        },
      };
    case ACTION_TYPES.LAB_RESULTS_CHART_READINGS_HISTORY_SUCCEED:
      return {
        ...state,
        status: {
          loadChartList: 1,
        },
        chartRecords: payload.data,
      };
    case ACTION_TYPES.LAB_RESULTS_CHART_READINGS_HISTORY_FAILED:
      return {
        ...state,
        status: {
          loadChartList: 2,
        },
        error,
      };
    default:
      return state;
  }
}
